"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotificationAlert = getNotificationAlert;
exports.areKeysSame = areKeysSame;
exports.getRefOfRequiredAttribute = getRefOfRequiredAttribute;
exports.setCountryNameToCode = setCountryNameToCode;
exports.getCountryCodeFromCountryName = getCountryCodeFromCountryName;
exports.checkAndCallBackToFullyResolved = checkAndCallBackToFullyResolved;
exports.onFullyResolved = onFullyResolved;
exports.getRequiredAttributes = getRequiredAttributes;
exports.getAttributesThoseHaveSingleValue = getAttributesThoseHaveSingleValue;
exports.getDerivedAttributes = getDerivedAttributes;
exports.getFilteredProductAttributeKeys = getFilteredProductAttributeKeys;
exports.cancelPromise = cancelPromise;
exports.convertNonProductAttributesInWhiteList = convertNonProductAttributesInWhiteList;
exports.getNonProductAttributes = getNonProductAttributes;
exports.addNonProductAttributesInRuleSet = addNonProductAttributesInRuleSet;
exports.getSkuFromRuleSet = getSkuFromRuleSet;
exports.getAuthoritativeRuleSet = getAuthoritativeRuleSet;
exports.doesHasCountryNameAlongWithCode = void 0;

var _react = _interopRequireDefault(require("react"));

var _i18nIsoCountries = _interopRequireDefault(require("i18n-iso-countries"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _find = _interopRequireDefault(require("lodash/find"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _map = _interopRequireDefault(require("lodash/map"));

var _union = _interopRequireDefault(require("lodash/union"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _get = _interopRequireDefault(require("lodash/get"));

var _constants = _interopRequireDefault(require("./constants"));

var _attributeSelectorUtils = require("./attributeSelectorUtils");

var _NotificationAlert = _interopRequireDefault(require("./NotificationAlert"));

var _services = require("./services");

function getNotificationAlert(message, type) {
  return _react["default"].createElement("div", {
    style: {
      padding: '20px'
    }
  }, _react["default"].createElement(_NotificationAlert["default"], {
    type: type,
    message: _react["default"].createElement("span", null, _react["default"].createElement("span", null, message), type !== 'info' ? _react["default"].createElement("div", null, _react["default"].createElement("span", null, "For help, please contact "), _react["default"].createElement("a", {
      href: "mailto:".concat(_constants["default"].PRODUCT_MARKETPLACE_SUPPORT_EMAIL, "?Subject= Price Attribute Aggregator Error"),
      target: "_top"
    }, "Product Tribe Support")) : null),
    dismissible: false
  }));
}

function areKeysSame(key1, key2) {
  if (key1 === key2) {
    return true;
  }

  if (key1 && key2 && key1.toLowerCase() === key2.toLowerCase()) {
    return true;
  }

  return false;
}

var doesHasCountryNameAlongWithCode = function doesHasCountryNameAlongWithCode(countryNameWithCode) {
  return countryNameWithCode && countryNameWithCode.indexOf('(') >= 0;
};
/**
 * Getting the attribute object from requiredAttributesWithValues onthe basis of key and scop/class
 */


exports.doesHasCountryNameAlongWithCode = doesHasCountryNameAlongWithCode;

function getRefOfRequiredAttribute(requiredAttributesWithValues, attributeKey) {
  return (0, _find["default"])(requiredAttributesWithValues, function (requiredAttributeWithValues) {
    return areKeysSame(requiredAttributeWithValues.key, attributeKey);
  });
}

function setCountryNameToCode(reqAttributeObject) {
  // Getting the attribute object from requiredAttributesWithValues onthe basis of key/name and scope/class
  if (reqAttributeObject) {
    var countryNameWithCode = reqAttributeObject.resolvedValue;

    if (!doesHasCountryNameAlongWithCode(countryNameWithCode)) {
      return reqAttributeObject;
    }

    reqAttributeObject.resolvedValue = getCountryCodeFromCountryName(countryNameWithCode);
  }

  return reqAttributeObject;
}

function getCountryCodeFromCountryName(countryNameWithCode) {
  if (!countryNameWithCode) {
    return undefined;
  }

  var indexOfBracket = countryNameWithCode.indexOf('(');
  var countryName = indexOfBracket === -1 ? countryNameWithCode : countryNameWithCode.substr(0, indexOfBracket).trim();
  return _i18nIsoCountries["default"].getAlpha2Code(countryName, 'en');
}
/**
 *
 * If all the values are present for required attributes then providing a call back to onFullyResolved function.
 */


function checkAndCallBackToFullyResolved(requiredAttributes, resolvedAttributes, displayedAttributes, onPartiallyResolvedCallBack, onFullyResolvedCallBack) {
  var fullyResolved = resolvedAttributes.find(function (each) {
    return areKeysSame(each.state, _constants["default"].FULLY_RESOLVED);
  });

  if (!fullyResolved) {
    onPartiallyResolvedCallBack(resolvedAttributes ? resolvedAttributes.map(function (each) {
      return each.attributes;
    }) : []);
  } else {
    onFullyResolvedCallBack(resolvedAttributes.filter(function (each) {
      return areKeysSame(each.state, _constants["default"].FULLY_RESOLVED);
    }).map(function (each) {
      return each.attributes;
    }), requiredAttributes);
  }
}

function onFullyResolved(requiredAttributesWithValues, resolvedAttributes, requiredAttributes, displayedAttributes, onPartiallyResolvedCallBack, onFullyResolvedCallBack) {
  // Checking required attributes are fully resolved or not
  checkAndCallBackToFullyResolved(requiredAttributesWithValues, resolvedAttributes, displayedAttributes, onPartiallyResolvedCallBack, onFullyResolvedCallBack);
}

function isHiddenAttribute(hiddenAttribute, formulaTypeAttributes, ruleSet) {
  if (!hiddenAttribute.isForceShowIfDerivingAttributes) {
    return true;
  } // Iterating `formulaTypeAttributes` if anyone of them is dependent on hidden attribute
  // and user wants to see them (by passing `isForceShowIfDerivingAttributes` as `true`) then we will return false


  var result = true;
  (0, _forEach["default"])(formulaTypeAttributes, function (formulaTypeAttribute) {
    var dependencies = !(0, _isEmpty["default"])(ruleSet) ? (0, _attributeSelectorUtils.findAttributeDependencies)(formulaTypeAttribute.name, ruleSet) : null;

    if (dependencies) {
      var regex = new RegExp(dependencies.join('|'), 'i');

      if (regex.test(hiddenAttribute.attributeKey)) {
        result = false;
      }
    }
  });
  return result;
}

function filterInputs(inputs, hiddenAttributes, ruleSet) {
  var filteredInputs = (0, _filter["default"])(inputs, function (input) {
    return !areKeysSame(input.name, _constants["default"].MCPSKU);
  }); // Filtering attributes those are type of `formula`

  var formulaTypeAttributes = (0, _filter["default"])(inputs, function (input) {
    return (0, _find["default"])(!(0, _isEmpty["default"])(ruleSet) ? ruleSet.whiteList : {}, function (attribute) {
      return areKeysSame(attribute.attributeKey, input.name) && areKeysSame(attribute.type, _constants["default"].FORMULA);
    });
  }); // Filtering hidden attributes

  filteredInputs = (0, _filter["default"])(filteredInputs, function (input) {
    return !(0, _find["default"])(hiddenAttributes, function (hiddenAttribute) {
      return areKeysSame(hiddenAttribute["class"], input.scope) && areKeysSame(hiddenAttribute.attributeKey, input.name) && isHiddenAttribute(hiddenAttribute, formulaTypeAttributes, ruleSet);
    });
  });
  return filteredInputs;
}

function getRequiredAttributes(inputs, sku, hiddenAttributes, ruleSet) {
  // Filtering hidden attributes from required inputs
  var filteredInputs = filterInputs(inputs, hiddenAttributes, ruleSet); // Setting all the keys of product and non product attribute keys with null value into object

  var requiredAttributesWithValuesModel = (0, _map["default"])(filteredInputs, function (attribute) {
    return {
      resolvedValue: null,
      key: attribute.name,
      "class": attribute.scope
    };
  });

  if (sku) {
    requiredAttributesWithValuesModel.push({
      resolvedValue: sku,
      key: _constants["default"].MCPSKU,
      "class": _constants["default"].PRODUCT
    });
  }

  return {
    requiredAttributesEntity: filteredInputs,
    requiredAttributesWithValuesModel: requiredAttributesWithValuesModel
  };
}

function isAttributeHasOnlySingleValue(attribute) {
  var isAttributeContainsOnlySingleValue = false;

  if (attribute.type === _constants["default"].LISTOFVALUES && attribute.attributeValues && attribute.attributeValues.length === 1) {
    isAttributeContainsOnlySingleValue = true;
  }

  return isAttributeContainsOnlySingleValue;
}

function getAttributesThoseHaveSingleValue(ruleSet, requiredAttributesEntity) {
  var attributesWithSingleValue = []; // if ruleSet or products attributes are empty then returning empty array.

  if (!(0, _get["default"])(ruleSet, 'whiteList') || !requiredAttributesEntity) {
    return attributesWithSingleValue;
  } // Finding attribute in rule set and checking weather it has single or multiple values


  (0, _forEach["default"])(requiredAttributesEntity, function (requiredAttribute) {
    var attributeWithSingleValue = (0, _find["default"])(ruleSet.whiteList, function (attribute) {
      return areKeysSame(attribute.attributeKey, requiredAttribute.name) && isAttributeHasOnlySingleValue(attribute);
    });

    if (attributeWithSingleValue) {
      attributesWithSingleValue.push(requiredAttribute.name);
    }
  });
  return attributesWithSingleValue;
}
/**
 *
 * This is `quantity` specific check, we will not consider attribute as derived attribute if it dervied by quantity and having option to select/fill values
 */


function isAttributeDependentOnQuantity(ruleSet, attributeKey, derivedFromList) {
  var isDependentOnQuantity = false;
  var regex = new RegExp(derivedFromList.join('|'), 'i'); // If attribute is not dependent on `quantity`

  if (!regex.test(_constants["default"].QUANTITY) || !ruleSet || !ruleSet.whiteList) {
    return isDependentOnQuantity;
  }

  (0, _find["default"])(ruleSet.whiteList, function (attribute) {
    // If attribute is dependent on `quantity` and not type of `formula` that's mean user can enter the value from the ui
    if (areKeysSame(attributeKey, attribute.attributeKey) && !areKeysSame(attribute.type, _constants["default"].FORMULA)) {
      isDependentOnQuantity = true;
    }
  });
  return isDependentOnQuantity;
}

function getDerivedAttributes(ruleSet, requiredAttributesEntity) {
  var attributeKeys = [];
  var attributeToShowList = [];

  if (requiredAttributesEntity) {
    attributeKeys = requiredAttributesEntity.map(function (attribute) {
      return attribute.name;
    });
  }

  var derivedAttributes = [];
  (0, _forEach["default"])(attributeKeys, function (attributeKey) {
    var dependencies = !(0, _isEmpty["default"])(ruleSet) ? (0, _attributeSelectorUtils.findAttributeDependencies)(attributeKey, ruleSet) : {}; // Checking if length of dependencies is more then 1, thats mean attribute is dependent on other attributes.
    // if length is 1, thats mean its not dependent on other attributes, because `dependencies` array will always contain value of same attribute on which you are checking

    if (dependencies && dependencies.length > 1) {
      // Filtering derived from list from attributes keys(all the keys of required attributes)
      var derivedFromList = (0, _filter["default"])(dependencies, function (dependency) {
        return attributeKeys.includes(dependency);
      });
      var attributeToShow = (0, _filter["default"])(dependencies, function (dependency) {
        return !attributeKeys.includes(dependency);
      });

      if (attributeToShow && attributeToShow.length > 0) {
        attributeToShowList = attributeToShowList.concat(attributeToShow);
      } // Checking if length of derivedFromList is more then 1, thats mean attribute is derived from other attributes.
      // if length is 1, thats mean its not derived from attributes, because `derivedFromList` array will always contain value of same attribute on which you are checking


      if (derivedFromList && derivedFromList.length > 1 && // This is `quantity` specific check, we will not consider attribute as derived attribute if it dervied by quantity and having option to select/fill values
      !isAttributeDependentOnQuantity(ruleSet, attributeKey, dependencies)) {
        derivedAttributes.push(attributeKey);
      }
    }
  }); // Filtering attributes those are having only single value, because there is no need to show them on ui.

  var attributesWithSingleValue = getAttributesThoseHaveSingleValue(ruleSet, requiredAttributesEntity);
  var derivedAndSingleValueAttributes = (0, _union["default"])(derivedAttributes, attributesWithSingleValue);
  return {
    derivedAttributes: derivedAndSingleValueAttributes,
    attributeToShowList: attributeToShowList.filter(function (each) {
      return !areKeysSame(each, 'Quantity');
    })
  };
}

function getFilteredProductAttributeKeys(attributes, derivedAttributes) {
  var filteredProductAttributeKeys = [];

  if (attributes) {
    var productAttributeKeys = (0, _map["default"])(attributes, function (attribute) {
      return attribute.name;
    }); // Filtering product attributes key from derived attributes because we don't want to see them on UI.

    filteredProductAttributeKeys = (0, _filter["default"])(productAttributeKeys, function (productAttributeKey) {
      return !derivedAttributes.includes(productAttributeKey);
    });
  }

  return filteredProductAttributeKeys;
}

function cancelPromise(cancelablePromise) {
  if (cancelablePromise) {
    cancelablePromise.cancel();
  }
}

function getAttributeValues(nonProductAttribute) {
  return areKeysSame(nonProductAttribute.name, _constants["default"].COUNTRY) && areKeysSame(nonProductAttribute.scope, _constants["default"].DESTINATION) ? (0, _services.transformInputs)(nonProductAttribute.inputValues) : nonProductAttribute.inputValues;
}

function getAttributeRanges(nonProductAttribute) {
  var attributeRanges = [];

  if (areKeysSame(nonProductAttribute.type, _constants["default"].ANY) || areKeysSame(nonProductAttribute.type, _constants["default"].RANGES)) {
    attributeRanges = (0, _isEmpty["default"])(nonProductAttribute.inputRanges) ? [{
      minimum: 0
    }] : nonProductAttribute.inputRanges;
  }

  return attributeRanges;
}

function convertNonProductAttributesInWhiteList(nonProductAttributes) {
  return (0, _map["default"])(nonProductAttributes, function (nonProductAttribute) {
    var attribute = {
      required: !nonProductAttribute.empty,
      derived: false,
      type: areKeysSame(nonProductAttribute.type, _constants["default"].VALUES) ? _constants["default"].LISTOFVALUES : _constants["default"].LISTOFRANGES,
      "class": nonProductAttribute.scope,
      attributeKey: nonProductAttribute.name
    };

    if (areKeysSame(nonProductAttribute.type, _constants["default"].ANY) || areKeysSame(nonProductAttribute.type, _constants["default"].RANGES)) {
      attribute.attributeRanges = getAttributeRanges(nonProductAttribute);
    } else {
      attribute.attributeValues = getAttributeValues(nonProductAttribute);
    }

    return attribute;
  });
}

function getNonProductAttributes(requiredAttributes) {
  return (0, _filter["default"])(requiredAttributes, function (input) {
    return !areKeysSame(input.name || input.attributeKey, _constants["default"].QUANTITY) && ((input.scope || input["class"]) === _constants["default"].DESTINATION || (input.scope || input["class"]) === _constants["default"].ORDER && !areKeysSame(input.name || input.attributeKey, _constants["default"].PRODUCTION_TIME));
  });
}

function addNonProductAttributesInRuleSet(ruleSet, requiredAttributes) {
  var nonProductAttributes = getNonProductAttributes(requiredAttributes);
  var ruleSetWithNonProductAttributes = (0, _cloneDeep["default"])(ruleSet);
  var nonProductAttributesWhiteList = convertNonProductAttributesInWhiteList(nonProductAttributes);

  if (ruleSet && ruleSet.whiteList) {
    ruleSetWithNonProductAttributes.whiteList = (0, _union["default"])(ruleSetWithNonProductAttributes.whiteList, nonProductAttributesWhiteList);
  }

  return ruleSetWithNonProductAttributes;
}

function getSkuFromRuleSet(ruleSet) {
  var skuReferenceId = null;

  if (!ruleSet) {
    return skuReferenceId;
  }

  var skuAttribute = (0, _filter["default"])(ruleSet.whiteList, function (attribute) {
    return areKeysSame(attribute.attributeKey, _constants["default"].MCPSKU);
  }); // If rule set is not having `mcpsku` attribute in whitelist that means its sku rule set.

  if ((0, _isEmpty["default"])(skuAttribute)) {
    skuReferenceId = ruleSet.referenceId;
  } else {
    // Get the sku only if there is single sku in ruleSet, that means family has single sku and we can get the data for it.
    skuReferenceId = skuAttribute && skuAttribute.length !== 0 && skuAttribute[0].attributeValues.length === 1 ? skuAttribute[0].attributeValues[0].value : null;
  }

  return skuReferenceId;
}

function getAuthoritativeRuleSet(ruleSets) {
  if (ruleSets && ruleSets.length === 1) {
    return ruleSets[0];
  }

  return !(0, _isEmpty["default"])(ruleSets) ? (0, _find["default"])(ruleSets, function (ruleSet) {
    return ruleSet.authoritative;
  }) : null;
}